import {
  INVOICE_CREATE_REQUEST,
  INVOICE_CREATE_SUCCESS,
  INVOICE_CREATE_FAIL,
  INVOICE_DETAILS_SUCCESS,
  INVOICE_DETAILS_REQUEST,
  INVOICE_DETAILS_FAIL,
  INVOICE_LIST_SUCCESS,
  INVOICE_LIST_REQUEST,
  INVOICE_LIST_RESET,
  INVOICE_LIST_FAIL,
  INVOICE_UPDATE_REQUEST,
  INVOICE_UPDATE_SUCCESS,
  INVOICE_UPDATE_RESET,
  INVOICE_UPDATE_FAIL,
  INVOICE_GET_REQUEST,
  INVOICE_GET_FAIL,
  INVOICE_GET_SUCCESS,
  INVOICE_LIST_TOTAL_REQUEST,
  INVOICE_LIST_TOTAL_FAIL,
  INVOICE_LIST_TOTAL_SUCCESS,
  INVOICE_DELETE_REQUEST,
  INVOICE_DELETE_SUCCESS,
  INVOICE_DELETE_FAIL,
} from "../constants/invoiceConstants";
import api from "../core/api";

export const listInvoices = (invoice) => async (dispatch, getState) => {
  try {
    dispatch({
      type: INVOICE_LIST_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await api.post(
      "/accounts/invoice/getInvoices",
      invoice,
      config
    );

    var dt = data.Result;

    if (typeof dt === "string") {
      dispatch({
        type: INVOICE_LIST_FAIL,
        payload: data.Result.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: INVOICE_LIST_SUCCESS,
        payload: dt,
      });
    }
  } catch (error) {
    dispatch({
      type: INVOICE_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const listInvoicesTotal = (invoice) => async (dispatch, getState) => {
  try {
    dispatch({
      type: INVOICE_LIST_TOTAL_REQUEST,
    });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await api.post(
      "/accounts/invoice/getInvoicesTotal",
      invoice,
      config
    );

    var dt = data.Result;

    if (typeof dt === "string") {
      dispatch({
        type: INVOICE_LIST_TOTAL_FAIL,
        payload: data.Result.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: INVOICE_LIST_TOTAL_SUCCESS,
        payload: dt[0].totalinvoices,
      });
    }
  } catch (error) {
    dispatch({
      type: INVOICE_LIST_TOTAL_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const createInvoice = (invoice) => async (dispatch, getState) => {
  try {
    dispatch({
      type: INVOICE_CREATE_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await api.post(
      "/accounts/invoice",
      invoice,
      config
    );

    var dt = data.Result;

    if (dt.includes("Error")) {
      dispatch({
        type: INVOICE_CREATE_FAIL,
        payload: dt.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: INVOICE_CREATE_SUCCESS,
        payload: dt,
      });
    }
  } catch (error) {
    dispatch({
      type: INVOICE_CREATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const deleteInvoice = (invoiceId) => async (dispatch, getState) => {
  try {
   
    dispatch({
      type: INVOICE_DELETE_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await api.delete(
      "/accounts/invoice/" + invoiceId,
      config
    );

    var dt = data.Result;

    if (dt.includes("Error")) {
      dispatch({
        type: INVOICE_DELETE_FAIL,
        payload: dt.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: INVOICE_DELETE_SUCCESS,
        payload: dt,
      });
    }
  } catch (error) {
    dispatch({
      type: INVOICE_DELETE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const updateInvoice = (invoice, id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: INVOICE_UPDATE_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await api.put(
      `/accounts/invoice/${id}`,
      invoice,
      config
    );

    var dt = data.Result;

    if (dt.includes("Error")) {
      dispatch({
        type: INVOICE_UPDATE_FAIL,
        payload: dt.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: INVOICE_UPDATE_SUCCESS,
        payload: dt,
      });
    }
  } catch (error) {
    dispatch({
      type: INVOICE_UPDATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const dataInvoice = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: INVOICE_GET_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await api.get(
      "/accounts/invoice/" + id,
      config
    );

    var dt = data.Result;

    if (dt.includes("Error")) {
      dispatch({
        type: INVOICE_GET_FAIL,
        payload: dt.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: INVOICE_GET_SUCCESS,
        payload: dt,
      });
    }
  } catch (error) {
    dispatch({
      type: INVOICE_GET_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const detailInvoice = (id) => async (dispatch, getState) => {
  try {
   dispatch({
      type: INVOICE_DETAILS_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await api.get(
      "/accounts/invoicedetails/" + id,
      config
    );

    var dt = data.Result;

    if (dt.includes("Error")) {
      dispatch({
        type: INVOICE_DETAILS_FAIL,
        payload: dt.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: INVOICE_DETAILS_SUCCESS,
        payload: dt,
      });
    }
  } catch (error) {
    dispatch({
      type: INVOICE_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
